const PEOPLE_BASE_ROUTE = '/people';

export const PEOPLE_API_ROUTES = {
  index: () => PEOPLE_BASE_ROUTE,
  peopleInfo: (peopleId: string) => `${PEOPLE_BASE_ROUTE}/${peopleId}`,
  editPeople: (peopleId: string) => `${PEOPLE_BASE_ROUTE}/edit/${peopleId}`,
  contactInfo: () => `${PEOPLE_BASE_ROUTE}/contact_info`,
} as const;
